import { publicRuntimeConfig } from "util/env-utils";
import { get } from "api/base";

type DVROptions = {
    startTimestamp: string | number;
    endTimestamp: string | number;
    streamId: string;
    allowDiscontinuity?: boolean;
};

const getDvrBlocksUrl = (options: DVROptions) => {
    const req = options;
    if (req.endTimestamp === Infinity) {
        delete req.endTimestamp;
    }

    const url = new URL(
        `${publicRuntimeConfig.UDVR_URL}/api/v2/dvr/contentmap`
    );
    for (const [key, value] of Object.entries(req)) {
        url.searchParams.set(key, value as string);
    }

    url.searchParams.set(`allowDiscontinuity`, `false`);

    return url;
};

/**
 * @summary - Fetches dvr content map
 */
export const getContentMap = async (options: DVROptions) => {
    const url = getDvrBlocksUrl(options);
    const { data } = await get(url.href, { withCredentials: true });
    return data;
};
